// const webBluetothMatrixURL = new URL("./pages/web-bluetooth-compatibility/index.html", import.meta.url);
const webBluetothMatrixURL = new URL("./pages/web-bluetooth-compatibility/", window.location.origin);

function mapMatrixOS(osName) {
  switch (osName) {
    case "Windows":
    case "Windows Phone":
    case "Windows Mobile":
      return "Windows";

    case "Mac OS":
      return "macOS";

    case "iOS":
      return "iOS";

    case "Android":
      return "Android";

    case "Chromium OS":
      return "ChromeOS";

    // Các distro Linux
    case "Linux":
    case "Ubuntu":
    case "Debian":
    case "Fedora":
    case "CentOS":
    case "Arch":
    case "Gentoo":
    case "Mint":
    case "RedHat":
    case "Slackware":
    case "SUSE":
    case "Mageia":
    case "Mandriva":
    case "PCLinuxOS":
    case "VectorLinux":
    case "Zenwalk":
    case "GNU":
    case "Linpus":
      return "Linux";

    default:
      return undefined;
  }
}

function mapMatrixBrowser(browserName) {
  switch (browserName) {
    // Chrome family
    case "Chrome":
    case "Chromium":
      return "Chrome";

    // Firefox family
    case "Firefox":
    case "Fennec":
    case "Firebird":
    case "IceCat":
    case "IceDragon":
    case "Iceweasel":
    case "Swiftfox":
      return "Firefox";

    case "Edge":
      return "Edge";

    // Safari
    case "Safari":
    case "Mobile Safari":
      return "Safari";

    // Nếu UAParser
    case "Samsung Internet":
    case "Samsung":
      return "Samsung";

    case "Bluefy":
      return "Bluefy";

    default:
      return undefined;
  }
}

export function getBLEMatrixURL(osName, browserName){
  const os = mapMatrixOS(osName);
  const browser = mapMatrixBrowser(browserName);
  
  if (!os) {
    return webBluetothMatrixURL;
  }

  const params = new URLSearchParams({
    os
  });

  if (browser) {
    params.set("browser", browser);
  }

  return `${webBluetothMatrixURL}?${params}`;
}
